import React, { useState, useEffect, useContext } from 'react';
import { getAppointments, deleteAppointment, getUsers, getAppointmentById } from '../api/api'; //se ha importado getAppointmentById
import AppointmentForm from '../components/AppointmentForm';
import { AuthContext } from '../context/AuthContext';
import '../index.css';
import './Users.css'; // Use the same CSS as Users
import Table from '../components/common/Table';
import Header from '../components/common/Header';
import Search from '../components/common/Search';
import Button from '../components/common/Button';
import Error from '../components/common/Error';

const Appointments = () => {
    const [appointments, setAppointments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [appointmentToEdit, setAppointmentToEdit] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [users, setUsers] = useState([]); //se ha añadido
    const { userRole } = useContext(AuthContext);

    const canCreate = userRole === "Director" || userRole === "Navegador";
    const canUpdate = userRole === "Director" || userRole === "Navegador";
    const canDelete = userRole === "Director" || userRole === "Navegador";
    const canRead = userRole === "Director" || userRole === "Navegador" || userRole === "Lector";

    useEffect(() => {
        const fetchAppointments = async () => {
            setLoading(true);
            try {
                const appointmentsData = await getAppointments();
                setAppointments(appointmentsData);
                const usersData = await getUsers(); //se han añadido los usuarios
                setUsers(usersData);
            } catch (err) {
                setError(err.message || 'Error al cargar las citas');
            } finally {
                setLoading(false);
            }
        };
        if (canRead) {
            fetchAppointments();
        } else {
            setError("No tienes permisos para ver las citas")
        }
    }, [canRead, userRole]);

    const handleCreate = () => {
        setAppointmentToEdit(null);
        setShowForm(true);
    };

    const handleEdit = async (id) => { // Se ha modificado
        try {
            const appointment = await getAppointmentById(id);
            setAppointmentToEdit(appointment);
            setShowForm(true);
        } catch (error) {
            setError(error.message || 'Error al cargar la cita');
        }
    };

    const handleDelete = async (id) => {
        try {
            await deleteAppointment(id);
            setAppointments(appointments.filter(appointment => appointment.id !== id));
        } catch (err) {
            setError(err.message || 'Error al eliminar la cita');
        }
    };
    const handleCloseForm = () => {
        setShowForm(false);
        setAppointmentToEdit(null);
    }

    const handleAppointmentUpdated = (newAppointment) => {
        setAppointments(appointments.map((appointment) => (appointment.id === newAppointment.id ? newAppointment : appointment)))
    }

    const handleAppointmentCreated = (newAppointment) => {
        setAppointments([...appointments, newAppointment])
    }
    // Función para filtrar las citas
    const filteredAppointments = appointments.filter((appointment) => {
        const appointmentValues = Object.values(appointment).join('').toLowerCase();
        return appointmentValues.includes(searchTerm.toLowerCase());
    });

    if (loading) return <div>Cargando...</div>;
    if (error) return <Error error={error} />;

    const tableHeaders = ["Título", "Usuario", "Fecha", "Especialidad", "Consultorio", "Doctor", "Instrucciones", "Dirección", "Tipo", "Nombre Ubicación", "Acciones"];

    // Función para truncar el texto
    const truncateText = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + "...";
        }
        return text;
    };

    const renderAppointmentRow = (appointment) => [ //se ha modificado
        truncateText(appointment.title, 30),
        appointment.user,
        appointment.date,
        appointment.specialty,
        appointment.office,
        appointment.responsible_doctor,
        truncateText(appointment.instructions, 30),
        truncateText(appointment.address, 30),
        appointment.appointment_type,
        appointment.location_name,
        [
            canUpdate && <Button onClick={() => handleEdit(appointment.id)}>Editar</Button>, //se envia el id
            canDelete && <Button onClick={() => handleDelete(appointment.id)}>Eliminar</Button>
        ]
    ];

    return (
        <div className='container'>
            <Header title="Gestión de Citas" />
            <Search searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            {canCreate && <Button onClick={handleCreate}>Crear Cita</Button>}
            {showForm && <div className='container-form'><AppointmentForm onClose={handleCloseForm} appointment={appointmentToEdit} onAppointmentUpdated={handleAppointmentUpdated} onAppointmentCreated={handleAppointmentCreated} users={users} /></div>}
            <Table headers={tableHeaders} data={filteredAppointments} renderRow={renderAppointmentRow} />
        </div>
    );
};

export default Appointments;
